<template>
  <div class="form-block">
    <div class="container-fluid">

      <div class="soh-list-view">
        <p v-if="heatSources.length === 0">Nie dodano żadnych źródeł ciepła</p>

        <div class="row" v-for="(heatSource, index) in heatSources" :key="index">
          <div class="col-12">
            <h2>Wybierz rodzaj źródła ciepła zainstalowanego w budynku</h2>
          </div>

          <div class="col-xs-12 col-md-7">
            <ZoneDropdown
              placeholder="Zainstalowane źródło ciepła"
              :items="heatSourceTypes"
              v-model="heatSource.type"
              class="installed-soh-type"
              :is-small="true"
              :multiline="true"
              :readonly="isEdited"
              @change="emitChange"
              :error="errors.sourcesOfHeats && errors.sourcesOfHeats[index] && errors.sourcesOfHeats[index].type"
            ></ZoneDropdown>
          </div>
          <div class="col-xs-12 col-md-5">
            <label>
              <input
                class="text-input w-small"
                type="number"
                step="1"
                v-on:keypress="numbersOnly"
                placeholder=""
                style="margin-top: .5rem"
                v-model="heatSource.amount"
                :class="{
                  'error': errors.sourcesOfHeats && errors.sourcesOfHeats[index] && errors.sourcesOfHeats[index].amount
                }"
              />
              Liczba zainstalowanych źródeł
            </label>
          </div>

          <div class="col-12">
            <h2>Określ, czy wybrane źródło ciepła jest eksploatowane</h2>
          </div>

          <div class="col-12">
            <label>
              <input
                type="checkbox"
                v-model="heatSource.isUsed"
                @change="clearCount(index)"
              >
              Czy źródło ciepła jest eksploatowane?
            </label>
            <label>
              <input
                class="text-input w-small side-margins"
                type="number"
                step="1"
                v-on:keypress="numbersOnly"
                v-model="heatSource.usedAmount"
                :disabled="!heatSource.isUsed"
                :class="{
                  'disabled': !heatSource.isUsed,
                  'error': errors.sourcesOfHeats && errors.sourcesOfHeats[index] && errors.sourcesOfHeats[index].usedAmount
                }"
              />
              Liczba eksploatowanych źródeł
            </label>
          </div>

          <div class="col-12">
            <h2 id="isUsedH2">Określ funkcje wybranego źródła ciepła</h2>
          </div>

          <div class="col-12 last-row-checkboxes">
            <label>
              <input
                type="checkbox"
                v-model="heatSource.centralHeating"
                :class="{'error': errors.sourcesOfHeats && errors.sourcesOfHeats[index] && errors.sourcesOfHeats[index].anyHeating}"
              >
              Źródło ciepła służy do ogrzewania (c. o.)
            </label>

            <label>
              <input
                type="checkbox"
                v-model="heatSource.waterHeating"
                :class="{'error': errors.sourcesOfHeats && errors.sourcesOfHeats[index] && errors.sourcesOfHeats[index].anyHeating}"
              >
              Źródło ciepła służy do podgrzewania wody (c. w. u.)
            </label>

            <label v-if="declarationType === 'B'">
              <input
                type="checkbox"
                v-model="heatSource.technicalHeating"
                :class="{'error': errors.sourcesOfHeats && errors.sourcesOfHeats[index] && errors.sourcesOfHeats[index].anyHeating}"
              >
              Funkcja technologiczna / produkcyjna
            </label>

          </div>

          <div class="col-12" v-if="declarationType === 'B'">
            <h2>Określ moc wybranego źródła ciepła</h2>
          </div>

          <div class="col-12" v-if="declarationType === 'B'">
            <label>
              Łączna moc źródła / źródeł (kW)
              <input
                id="kWinput"
                class="text-input w-small side-margins"
                type="number"
                v-model="heatSource.powerConsumption"
              />
            </label>
            <b-tooltip  target="kWinput"  triggers="hover">
                Wartość <b>nie może być przedziałem</b>, a wartości dziesiętne powinny być oddzielone <b>kropką</b>.
            </b-tooltip>
          </div>

          <div class="col-12" v-if="!isEdited">
            <button type="button" class="btn btn-link" @click="removeHeatSource(index)">
              Usuń źródło ciepła
            </button>
          </div>

          <div class="col-12">
            <hr/>
          </div>

        </div>

        <div class="col-12 add-new-col" v-if="!isEdited">
          <a href="#" @click="addEmptyHeatSource">
            <ZoneIcon icon-name="Plus"/>
            <label>Dodaj kolejne źródło ciepła</label>
          </a>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import InputDropdown from "@/components/common/InputDropdown";
import ZoneIcon from "@/components/common/ZoneIcon";
import DeclarationModel from "@/models/declarations";
import ZoneDropdown from "@/components/common/ZoneDropdown";
import Common from "@/components/declarations/validators/Common";
import DeclarationsMixin from "@/mixins/DeclarationsMixin";

export default {
  name: "SecondScreen",
  mixins: [Common, DeclarationsMixin],
  components: {ZoneDropdown, ZoneIcon, InputDropdown},
  data() {
    return {
      isEdited: false,
      heatSources: [],
      heatSourceTypes: [],
    }
  },
  methods: {
    clearCount(index) {
      if (!this.heatSources[index].isUsed) {
        this.heatSources[index].usedAmount = null;
      }
    },
    setData(data) {
      this.isEdited = data.is_edited;
      if (!data.sources_of_heat.length) {
        return;
      }
      this.heatSources = data.sources_of_heat.map((soh) => {
        return {
          id: soh.id,
          type: soh.type,
          isUsed: soh.used_count > 0,
          amount: soh.amount,
          usedAmount: soh.used_count,
          waterHeating: soh.water_heating,
          centralHeating: soh.central_heating,
          technicalHeating: soh.production_B,
          powerConsumption: soh.power_B,
        };
      });
    },
    emitChange() {
      const data = {
        heatSources: [],
        solidFuel: false
      };
      data.heatSources = this.heatSources.map((el) => {
        if (el.type.is_solid_fuel) {
          data.solidFuel = true;
        }
        let parsedHeatSource = {
          type: el.type.type,
          amount: el.amount || 0,
          is_used: el.isUsed,
          used_count: el.usedAmount || 0,
          water_heating: el.waterHeating,
          central_heating: el.centralHeating,
          production_B: el.technicalHeating,
          power_B: el.powerConsumption || null
        };
        if (el.id) {
          parsedHeatSource.id = el.id;
        }
        return parsedHeatSource;
      });
      if (data.heatSources.length === 1 && data.heatSources[0].amount === 0) {
        data.heatSources = [];
      }
      this.$emit('update', data);
    },
    getHeatSources() {
      DeclarationModel.getHeatSources()
        .then((res) => this.heatSourceTypes = res.data);
    },
    removeHeatSource(index) {
      this.heatSources.splice(index, 1);
    },
    addEmptyHeatSource() {
      const data = {
        type: {},
        isUsed: false,
        amount: null,
        usedAmount: null,
        waterHeating: false,
        centralHeating: false,
        technicalHeating: false,
        powerConsumption: null,
        declaration: null
      }
      this.heatSources.push(data);
    },
    numbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  },
  mounted() {
    // this.addEmptyHeatSource();
    this.getHeatSources();
  }
}
</script>

<style scoped>
h1, h2, h3, h4, label, p {
  color: #707070;
}

.soh-list-view {
  height: 29rem;
  min-height: 25rem;
  overflow-y: scroll;
  width: 100%;
}

a, a label {
  color: #000000;
  cursor: pointer;
}

a label {
  padding: 0 1rem;
  font-family: "Volte Semibold", serif;
  color: #6e7182;
  cursor: pointer;
}

h2 {
  font-size: 1.2rem;
  font-family: "Volte Semibold", serif;
}

.in-use-count-input {
  width: 18rem;
  margin-left: 2rem;
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid #000000;
}

.row {
  width: 100%;
}

.last-row-checkboxes label {
  padding-right: 2rem;
}

.bottom-row {
  position: absolute;
  bottom: 1.4rem;
  left: 2rem;
}

input[type=text] {
  height: 2rem;
}

.add-new-col {
  padding-left: 0;
}

.text-input {
  height: 2rem;
}

@media screen and (max-width: 768px) {

  .soh-list-view {
    height: auto;
    min-height: 10rem;
    overflow-y: hidden;
    width: 100%;
  }
}
</style>
